import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getNhDealApplicationId } from "features/authSlice";
import { getLoanOfficerDetail } from "services/common/loanOfficerSlice";
import { useGetloanOfficerQuery } from "pages/application/applicationService";

/*
 * prefer the fresh API response over the persisted cache once it resolves, so a
 * reassigned LO or a loan switch is never masked by a stale cached value. The persisted cache
 * is only used to paint instantly before the network response for this deal comes back.
*/
export const useLoanOfficer = () => {
  const nhDealApplicationId = useSelector(getNhDealApplicationId);
  const loanOfficerFromCache = useSelector(getLoanOfficerDetail);

  const {
    data: loanOfficerFromApi,
    isLoading,
    isSuccess,
    error,
  } = useGetloanOfficerQuery(nhDealApplicationId, {
    skip: !nhDealApplicationId,
    refetchOnMountOrArgChange: true,
  });

  const loanOfficer = useMemo(() => {
    return loanOfficerFromApi ?? loanOfficerFromCache ?? undefined;
  }, [loanOfficerFromCache, loanOfficerFromApi]);

  return {
    loanOfficer,
    isLoading,
    isSuccess,
    error,
    hasLoanOfficer: !!loanOfficer
  };
};
